// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Description_wrapper__3YSqc","label":"Description_label__1GZUO"};